import { render, staticRenderFns } from "./TestGatewayButton.vue?vue&type=template&id=34ccdaa1&"
import script from "./TestGatewayButton.vue?vue&type=script&lang=js&"
export * from "./TestGatewayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports